import React from 'react';
import { twMerge } from 'tailwind-merge';

import {
  MAX_SELECTION_DURATION,
  MIN_SELECTION_DURATION,
} from '../utils/constants';

interface DurationLabelProps {
  duration: number;
  /** Width of selection in pixels - used to determine label format */
  selectionWidth?: number;
  className?: string;
}

const MIN_WIDTH_FOR_FULL_LABEL = 120;
const MIN_WIDTH_FOR_SHORT_LABEL = 60;

/** Displays the selected clip duration centered in the selection indicator. */
export default function DurationLabel({
  duration,
  selectionWidth = MIN_WIDTH_FOR_FULL_LABEL,
  className = '',
}: DurationLabelProps) {
  if (duration <= MIN_SELECTION_DURATION) return null;
  if (selectionWidth < MIN_WIDTH_FOR_SHORT_LABEL) return null;

  const formattedDuration = duration.toFixed(2).padStart(5);
  const showMaxSuffix = selectionWidth >= MIN_WIDTH_FOR_FULL_LABEL;

  return (
    <div
      className={twMerge(
        'absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2',
        'px-1 py-px rounded text-xs font-normal',
        'bg-gray-900 bg-opacity-70 text-white',
        'pointer-events-none select-none z-10',
        'transition-all duration-150',
        'leading-4 whitespace-nowrap',
        className
      )}
      data-testid="duration-label"
    >
      {formattedDuration}
      {showMaxSuffix ? ` • ${MAX_SELECTION_DURATION}s max` : ''}
    </div>
  );
}
